import axios from "axios"

export const getPackages = async (params = {}) => {
  return await axios.get("/system_configurations/package/", { params })
}

export const createPackage = async (payload = {}) => {
  return await axios.post(`/system_configurations/package/`, payload)
}

export const deletePackage = async id => {
  return await axios.delete(`/system_configurations/package/${id}/`)
}

export const updatePackage = async payload => {
  const { id, data } = payload
  return await axios.patch(`/system_configurations/package/${id}/`, data)
}
